'use client';

import type { ReactNode } from 'react';
import { VStack } from '@terra/ui-styled-system';
import { LIST_PAGE_TABLE_HEADER_HEIGHT_PX } from './list-page-table-theme';

export function ListPageTableBodyLayer({ children }: { children: ReactNode }) {
  return (
    <VStack
      position="absolute"
      style={{ top: LIST_PAGE_TABLE_HEADER_HEIGHT_PX }}
      left={0}
      right={0}
      bottom={0}
      zIndex={1}
      gap={0}
      alignItems="stretch"
      bg="bg.canvas"
    >
      {children}
    </VStack>
  );
}
